import { trackMixpanelPageView } from '@helpers/post';
import './UserRole.scss';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { ReactComponent as BagIcon } from './icon-bag.svg';
import { ReactComponent as MagIcon } from './icon-mag.svg';
import { ReactComponent as WhiteMagIcon } from './icon-mag-white.svg';
import { ReactComponent as WhiteBagIcon } from './icon-bag-white.svg';
import CustomRadioCheckBox from 'components/V2/CustomInputs/CustomRadioCheckBox';
import classNames from 'classnames';
import { Button } from 'reactstrap';
import { useQueryParamCapture } from '@helpers/useQueryParamCapture';

const EVENT_OPERATOR = 'EventOperator';
const ATHLETIC_TRAINER = 'AthleticTrainer';

const UserRole = props => {
  const [type, setType] = useState('');
  const isEventOperator = type === EVENT_OPERATOR;
  const isAthleticTrainer = type === ATHLETIC_TRAINER;
  const buttonDisabled = type === '';

  // Automatically capture query parameters (whitelisted route)
  useQueryParamCapture();

  useEffect(() => {
    trackMixpanelPageView('/create-account/role');
  }, []);

  const onClickHireAthleticTrainer = () => {
    props.history.push('organization-type');
  };

  const onClickFindWork = () => {
    trackMixpanelPageView('intro_at_signup_link_clicked', props.user);

    props.history.push('athletic-trainer-sign-up');

    // const link = 'https://www.go4.io/athletic-trainers/?account-modal=true';
    // window.open(link, '_blank', 'noopener, noreferrer');
  };

  const onContinue = () => {
    if (type === ATHLETIC_TRAINER) {
      onClickFindWork();
      return;
    }

    onClickHireAthleticTrainer();
  };

  return (
    <div className="UserRole">
      <header>
        <div className="screen-title">What can we help you with?</div>
      </header>

      <main>
        <div className="user-type-section">
          <div
            className={classNames('type', {
              'selected-border': isEventOperator,
            })}
            onClick={() => setType(EVENT_OPERATOR)}
          >
            {isEventOperator ? <WhiteMagIcon /> : <MagIcon />}
            <p>Hire an athletic trainer</p>
            <CustomRadioCheckBox
              id="hire-an-athletic-trainer"
              name="Hire an Athletic Trainer"
              checked={isEventOperator}
              value="hire-an-athletic-trainer"
              className={isEventOperator && 'white'}
            />
          </div>

          <div
            className={classNames('type', {
              'selected-border': isAthleticTrainer,
            })}
            onClick={() => setType(ATHLETIC_TRAINER)}
          >
            {isAthleticTrainer ? <WhiteBagIcon /> : <BagIcon />}
            <p>Find work</p>
            <CustomRadioCheckBox
              id="find-work"
              name="Find work"
              checked={isAthleticTrainer}
              value="find-work"
              className={isAthleticTrainer && 'white'}
            />
          </div>
        </div>

        <Button
          onClick={onContinue}
          className="continue-button"
          block
          color="success"
          disabled={buttonDisabled}
        >
          <div>Continue</div>
        </Button>
      </main>
    </div>
  );
};

export default withRouter(UserRole);
